import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "./providers/ThemeProvider";
import { PortalConfigProvider } from "./providers/PortalConfigProvider";
import { App } from "./App";

// PortalConfigProvider wraps the whole app: it loads /api/portal-config
// at startup, wires the module-level OktaAuth holder if auth is on,
// and renders a loading spinner until done. Children of <App /> can
// then use both getOktaAuth() (synchronous) and usePortalConfig()
// (React context) confident the bootstrap has completed.

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <CssBaseline />
        <PortalConfigProvider>
          <App />
        </PortalConfigProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
